import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "../styles/Header.module.css";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  // const [showMenu, setShowMenu] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/"; // Check if current route is homepage
  // const toggleMenu = () => {
  //   setShowMenu(!showMenu);
  // };
  
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50 && !isHome) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);
  
  return (
    <header className={styles.header}>
      <div className={styles.headerInner}>
        {/* Logo Section - hidden if on homepage */}
        <div className={`${styles.logoContainer} ${scrolled ? styles.logoFade : ""}`}>
          {!isHome ? (
            <Link to="/" title="Tiktok Agency Cr8tiv">
              <img
                itemProp="image"
                src="/cr8tiv.svg"
                alt="Tiktok Agency Cr8tiv"
                width={600}
                height={160}
                loading="eager"
                className={styles.logo}
              />
            </Link>
          ) : (
            <div className={styles.logoPlaceholder}></div>
          )}
        </div>

        {/* Menu Commented Out */}
        {/*
        <nav className={showMenu ? styles.show : styles.hide}>
          <ul className={styles.menu}>
            <li>
              <Link to="/tiktok-agency" title="About Cr8tiv TikTok Agency">
                <img
                  itemProp="image"
                  src="/like.svg"
                  alt="About Cr8tiv TikTok Agency"
                  width={60}
                  height={60}
                  loading="eager"
                  className={styles.butimg}
                />
                <p className={styles.menubut}>About us</p>
              </Link>
            </li>
            <li>
              <Link to="/tiktok-live-support" title="TikTok Live Support and Creator Network">
                <img
                  itemProp="image"
                  src="/tiktok-agency-services-cr8tiv.svg"
                  alt="Cr8tiv TikTok Live Support and Creator Network"
                  width={60}
                  height={60}
                  loading="eager"
                  className={styles.butimg}
                />
                <p className={styles.menubut}>Support</p>
              </Link>
            </li>
            <li>
              <Link to="/tiktok-creator-network-strategy" title="TikTok Creator Network Strategy">
                <img
                  itemProp="image"
                  src="/tiktok-agency-strategy.svg"
                  alt="TikTok Creator Network Strategy by Cr8tiv Agency"
                  width={60}
                  height={60}
                  loading="eager"
                  className={styles.butimg}
                />
                <p className={styles.menubut}>Strategy</p>
              </Link>
            </li>
            <li>
              <Link to="/news" title="Social Media and TikTok News">
                <img
                  itemProp="image"
                  src="/social-media-news.svg"
                  alt="Latest Social Media and TikTok News"
                  width={60}
                  height={60}
                  loading={isHome ? "eager" : "lazy"}
                  className={styles.butimg}
                />
                <p className={styles.menubut}>News</p>
              </Link>
            </li>
            <li>
              <Link to="/tiktok-agency-faq" title="Frequently Asked Questions about TikTok Agency">
                <img
                  itemProp="image"
                  src="/tiktok-agency-faq.svg"
                  alt="TikTok Agency Frequently Asked Questions"
                  width={60}
                  height={60}
                  loading="eager"
                  className={styles.butimg}
                />
                <p className={styles.menubut}>FAQ</p>
              </Link>
            </li>
            <li>
              <Link to="/tiktok-live-agency-contact" title="Contact Cr8tiv TikTok Live Agency">
                <img
                  itemProp="image"
                  src="/tiktok-agency-contact.svg"
                  alt="Contact Cr8tiv TikTok Live Agency"
                  width={60}
                  height={60}
                  loading="eager"
                  className={styles.butimg}
                />
                <p className={styles.menubut}>Contact</p>
              </Link>
            </li>
          </ul>
        </nav>
        */}

        {/* Hamburger Button Commented Out */}
        {/*
        <div
          className={styles.hamb}
          onClick={toggleMenu}
          id="Cr8tivmenu"
          title="Toggle Menu"
        >
          {showMenu ? (
            <span className={styles.close}></span>
          ) : (
            <span className={styles.hambline}></span>
          )}
        </div>
        */}
      </div>
    </header>
  );
};

export default Header;